/**
 * @file 是否打印答案
 * @description 讲义打印页勾选状态写入 localStorage；没有缓存时默认勾选。
 *
 * @whenToUse 讲义打印筛选栏「是否打印答案」。
 * @whenNotToUse 其他页面的本地偏好。
 */

/** localStorage 键：`1` 打印答案，`0` 不打印 */
const PRINT_ANSWERS_KEY = 'handout-print-answers'

/**
 * 读取是否打印答案。
 * @returns 已缓存的勾选状态；没有缓存时为 true
 */
export function readPrintAnswers(): boolean {
  const raw = localStorage.getItem(PRINT_ANSWERS_KEY)
  if (raw === null) return true
  return raw === '1'
}

/**
 * 写入是否打印答案。
 * @param printAnswers 勾选为 true
 */
export function writePrintAnswers(printAnswers: boolean): void {
  localStorage.setItem(PRINT_ANSWERS_KEY, printAnswers ? '1' : '0')
}
